import React from 'react'

const Loader = () => {
  return (
    <div className='flex items-center justify-center h-[90vh]'>
        <img src="https://i.ibb.co/6g9hsNF/2c2e8cc2269e65efbdb7fed6f5a2abf6.gif" alt="loader" />
    </div>
  )
}

export default Loader